import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {menuTableReady,rowsPerPageState,searchTextState,paginationState,menuIdForAction,previousFilterCity,previousFilterSku} from '../redux/menus'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/menuTable.css'


import {Cities,MenuSKUFilter} from '../../../common/DropDowns/index'

import {  AddSku } from './ActionButtons'

import * as Helpers from '../../../common/helpers'


import { CSVLink } from 'react-csv'
import { createXLSheetdata } from '../services/helpers'

//import DateRangePicker from 'react-bootstrap-daterangepicker'
import 'react-bootstrap-daterangepicker/css/daterangepicker.css'
import moment from 'moment'




function getFiltertedMenu(type,menusData) {
    let newArray = []
    for (let i = 0; i < menusData.length; i++) {
            if(type==="0" && (menusData[i].product_id==="" || menusData[i].product_id===undefined)){
                    newArray.push(menusData[i])
            }else if(menusData[i].product_id!=="" && menusData[i].product_id!==undefined && type==="1") {
                    newArray.push(menusData[i])
            }
        }
    return newArray;
}
function filterUnwantedData(menusData) {
    let array = []
    if (menusData && menusData.data && menusData.data.list) {
        array = menusData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.up_id = lineData.up_id ? lineData.up_id : "NA"
            newLineData.product_id = lineData.product_id ? lineData.product_id : ""
            newLineData.name = lineData.name ? lineData.name : "NA"
            newLineData.type = lineData.type ? lineData.type : ""
            newLineData.price = lineData.price ? lineData.price : ""
            newLineData.city = lineData.city && lineData.city.name ? lineData.city.name : "NA"
            newLineData.city_id = lineData.city_id ? lineData.city_id : ""
            newLineData.category = lineData.category && lineData.category.name ? lineData.category.name : "NA"

            newLineData.product_id = lineData.product_id ? lineData.product_id : ""
            newLineData.weight = lineData.weight ? lineData.weight : ""

            newLineData.sku_name = lineData.product &&  lineData.product.name && lineData.product.name ? lineData.product.name : ""

            newLineData.sku = lineData.product &&  lineData.product.sku && lineData.product.sku ? lineData.product.sku : ""

            newLineData.sku_combined=newLineData.sku+" - "+newLineData.sku_name

            newArray[i] = newLineData
        }
    }
    return newArray
}


class MenusTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            allMenuData:[],
            menuData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            filter_city:"",
            filter_sku:"ALL",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null
        this.CSVData = []
        this.createCSVData = this.createCSVData.bind(this)
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(menuTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.MENUS_TABLE))
        this.props.dispatch(subHeaderDataUpdate())


        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

            let previousFilterCity=""
            let previousFilterSku=""

         if (this.props.menus && this.props.menus.previousFilterCity && this.props.menus.previousFilterCity!==undefined) {
            previousFilterCity=this.props.menus.previousFilterCity
         }  
          if (this.props.menus && this.props.menus.previousFilterSku && this.props.menus.previousFilterSku!==undefined) {
            previousFilterSku=this.props.menus.previousFilterSku
         }         
       

         if(previousFilterCity===undefined || previousFilterCity===null || previousFilterCity===""){
            previousFilterCity=""
         }

         if(previousFilterSku===undefined || previousFilterSku===null || previousFilterSku===""){
            previousFilterSku=""
         }
         
         this.setState({
              filter_city:previousFilterCity,
              filter_sku:previousFilterSku
         },() => {
            this.getMenusData();
        });

        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }

      createCSVData(csvData) {
        let menuDetails = []
        if (csvData) {
            menuDetails = JSON.parse(JSON.stringify(csvData))
            menuDetails = createXLSheetdata(menuDetails)
        }
        this.CSVData = menuDetails
    }


    
    getMenusData = () => {
        apiService.getMenusData(this.state.filter_city)
            .then(menusData => {
                if (menusData && this.isComponentMounted) {
                    this.validateBuildNumber(menusData)
                    if (menusData.status === "SUCCESS") {
                        let array = filterUnwantedData(menusData), pageNo = 1
                        if (this.props.menus && this.props.menus.previousPaginationValue) {
                            pageNo = this.props.menus.previousPaginationValue
                        }
                        this.setState({
                            allMenuData:array,
                            menuData: array,
                            page: pageNo,
                        })

                        this.filterSKU()

                        this.createCSVData(this.state.menuData)

                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: menusData.reason ? menusData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(menuTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(menuTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

     cityChange= (data) => {
    
      if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterCity(""))
             this.setState({
                filter_city :"",            
            })
        }else{
            this.props.dispatch(previousFilterCity(data.value))
            this.setState({
                filter_city :data.value,            
            })
        }
    }


     skuFilterChange= (data) => {
    
      if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterSku(""))
             this.setState({
                filter_sku :"ALL",            
            })
             this.filterSKU()
        }else{
            this.props.dispatch(previousFilterSku(data.value))
            this.setState({
                filter_sku :data.value,            
            })
        }
    }

    filterSKU=()=>{
        if(this.state.filter_sku==="1"){

             let array = getFiltertedMenu(this.state.filter_sku,this.state.allMenuData)
                        this.setState({
                            menuData: array,
                            page: 1,
                        })

        }else if(this.state.filter_sku==="0"){
            let array = getFiltertedMenu(this.state.filter_sku,this.state.allMenuData)
                        this.setState({
                            menuData: array,
                            page: 1,
                        })
        }else{
                this.setState({
                    menuData: this.state.allMenuData,
                    page: 1,
                })
        }
       
    }

   

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.menus && this.props.menus.previousRowsPerPageValue) {
            value = this.props.menus.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

   

    createCustomToolBar = props => {


        let menuDetailsFilename = "menuDetails_" + moment().format("MM/DD/YYYY") + "-" +
            moment().format("h:mm:ss") + ".csv"
        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">
                {/*
                   {(() =>{

                    if(Helpers.checkPrivileges("/dashboard/menus/addEdit",this.props.user)){
                    return(
                        <div className="col-md-1 col-sm-12 col-xs-12 div-margins">
                            <button className="btn btn-primary button-custom"
                                    style={{ marginLeft: "5px" }}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        this.props.dispatch(menuIdForAction())
                                        this.props.history.push("/dashboard/menus/addEdit")
                                    }}>
                                    Add
                                </button>
                         </div>

                        )
                      }
                   })()}
                */}
                   
                   
                    <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                        <div className="form-group">
                            <Cities cityChange={this.cityChange} selectedValue={this.state.filter_city} /> 
                        </div>
                    </div>
                   
                    <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                        <div className="form-group">
                            <MenuSKUFilter skuFilterChange={this.skuFilterChange} selectedValue={this.state.filter_sku} /> 
                        </div>
                    </div>

                    

                    <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                        <button className="btn btn-primary button-custom"
                            onClick={(e) => {
                                e.preventDefault()
                                this.getFilteredMenusList()
                            }}>
                            Go
                        </button>
                        <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                this.resetFilterValues()
                            }}>
                            Clear
                        </button>

                        <CSVLink
                            data={this.CSVData}
                            className="btn btn-primary button-custom"
                            style={{ marginLeft: "10px",background: "#3c8dbc",border:"1px solid #3c8dbc"}}
                            filename={menuDetailsFilename}>
                            Export
                        </CSVLink>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.menuData.length>=(this.props.menus.previousPaginationValue*this.props.menus.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.menus.previousPaginationValue*this.props.menus.previousRowsPerPageValue)-this.props.menus.previousRowsPerPageValue+1} to {this.props.menus.previousPaginationValue*this.props.menus.previousRowsPerPageValue} of {this.state.menuData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.menus.previousPaginationValue*this.props.menus.previousRowsPerPageValue)-this.props.menus.previousRowsPerPageValue+1} to {this.state.menuData.length} of {this.state.menuData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }

    getFilteredMenusList = () => {
       
        this.props.dispatch(menuTableReady(false))
        this.resetSearchAndPagination()
        this.getMenusData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    
   

    resetFilterValues = () => {
        this.props.dispatch(menuTableReady(false))
        this.setState({
            filter_city:"",
            filter_sku:"ALL",
        },() => {
             this.resetPagination()
        
            this.props.dispatch(searchTextState(""))
            this.searchBox.wrappedInstance.refs.searchInput.value = ""
            this.searchBox.props.search("")

            this.props.dispatch(previousFilterCity(""))
            this.props.dispatch(previousFilterSku(""))

            this.getMenusData()
        });

        
    }




      renderWeight = (cell, row) => {

        let renderWeight=""

         if(row.weight===undefined || row.weight===""){
            renderWeight=<p class="no-weight">NOT FOUND</p>
            
        }else{
            renderWeight=<p>{row.weight}</p>
        }


        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{renderWeight}</div>
        </div>)


    }

      renderSKU = (cell, row) => {

        let mapSku=""

         if(row.product_id===undefined || row.product_id==="" ){
            mapSku=<p class="no-sku">NOT FOUND</p>
            
        }else{
            mapSku=<p>{row.sku_combined}</p>
        }


        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{mapSku}</div>
        </div>)


    }

    actionButtonsCreator = (cell, row) => {
        let editButton =""


        if(Helpers.checkPrivileges("/dashboard/menus/addEdit",this.props.user) && row.product_id!==undefined && row.product_id!=="" ){
        
            editButton=<AddSku title="Edit" data={row}/>
        }else{
            editButton=<AddSku title="Add" data={row}/>
        }

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{editButton}</div>
        </div>)
    }

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.menus && this.props.menus.previousPaginationValue
            && this.props.menus.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }

    editMenu = (row) => {
        if (row && row.id) {
            this.props.dispatch(menuIdForAction(row.id))
            this.props.history.push("/dashboard/menus/addEdit")
        } else {
            this.dialog.show({
                title: "Brand Identification number not found",
                body: 'Brand id is not available, So not able edit menu',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }

    render() {
        let sizeperPage = 15

        if (this.props.menus && this.props.menus.previousRowsPerPageValue) {
            sizeperPage = this.props.menus.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="menus-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.menuData}
                    pagination={true}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight }}>

                    {(() =>{
                        if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
                                return(     
                                       <TableHeaderColumn
                                            dataField="id"
                                            width="80"
                                            dataSort={true}
                                            isKey={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            ID
                                        </TableHeaderColumn>
                                    )
                                }else{
                                    return(
                                        <TableHeaderColumn
                                            dataField="id"
                                            width="1"
                                            isKey={true}
                                            hidden={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            Id
                                        </TableHeaderColumn>
                                    )
                                }
                        })()}


                    <TableHeaderColumn
                        dataField="up_id"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Urbanpiper Id
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Name
                    </TableHeaderColumn>


                    <TableHeaderColumn
                        dataField="sku"
                        dataSort={true}
                        hidden={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Name
                    </TableHeaderColumn>


                    <TableHeaderColumn
                        dataField="sku_name"
                        dataSort={true}
                        hidden={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Name
                    </TableHeaderColumn>



                    <TableHeaderColumn
                            dataFormat={this.renderSKU}
                            dataAlign='center'
                            tdStyle={{ whiteSpace: 'normal' }}>
                        SKU
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataFormat={this.renderWeight}
                        dataSort={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Weight [ gms ]
                    </TableHeaderColumn>
                    
                    

                    <TableHeaderColumn
                        dataField="type"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Type
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataField="city"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        City
                    </TableHeaderColumn>
                    
                    
                    <TableHeaderColumn
                        dataField="category"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Category
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataField="price"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Price
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                            //width="110"
                        dataField="id"
                        dataFormat={this.actionButtonsCreator}
                        filterFormatted={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>
                    
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        menus: state.menus
    }
}

export default connect(mapStateToProps)(withRouter(MenusTable))


// WEBPACK FOOTER //
// ./src/modules/Menus/Components/MenusTable.js